// extracted by mini-css-extract-plugin
module.exports = {"main":"SearchBar_main__1AEzD","bar":"SearchBar_bar__2VW4k"};